import { Accordion, AccordionDetails, AccordionSummary, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Typography } from "@mui/material";
import { Component } from "react";
import { BsBuildings } from "react-icons/bs";
import BasicDataGrid from "../../ui/BasicDataGrid";
import { MdClose, MdDelete, MdEdit } from "react-icons/md";
import NomeInput from "../../ui/NomeInput";
import NumEmpInput from "../../ui/NumEmpInput";
import CodFilInput from "../../ui/CodFilInput";
import { httpGet, httpPost } from "../../util/http";
import StatusAlert from "../../ui/StatusAlert";
import RoundButton from "../../ui/RoundButton";
import ClasseSelect from "../../ui/ClasseSelect";

export default class Unidades extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showForm: false,
            showDelete: false,
            unidades: [],
        }
        this.columns = [
            { field: 'unidade', headerName: 'Unidade', flex: 1, valueGetter: (params) => params.row?.nome },
            { field: 'classe', headerName: 'Classe', width: 120, valueGetter: (params) => params.row?.classe?.nome },
            { field: 'numemp', headerName: 'Núm. Emp.', flex: 1, valueGetter: (params) => params.row?.sapiens_numemp },
            { field: 'codfil', headerName: 'Cód. Fil.', flex: 1, valueGetter: (params) => params.row?.sapiens_codfil },
            {
                field: 'action', headerName: 'Ações', width: 100, renderCell: (params) => <>
                    <IconButton title="Editar" onClick={e => this.onEditClick(params)} color="primary"><MdEdit size={16} /></IconButton>
                    <IconButton title="Remover" onClick={e => this.onRemoveClick(params)} color="primary"><MdDelete size={16} /></IconButton>
                </>
            },
        ];
    }

    componentDidMount() {
        this.refresh();
    }

    refresh() {
        this.setState({ loading: true });
        httpGet('/unidades/list',
            unidades => {
                unidades.forEach(unidade => {
                    if (unidade.classe) {
                        unidade.classe = { codClass: unidade.classe, nome: 'Classe ' + unidade.classe }
                    } else {
                        unidade.classe = null;
                    }
                });
                //console.log(unidades)
                this.setState({
                    unidades,
                    loading: false,
                });
            },
            error => {
                console.log(error);
                this.setState({ loading: false });
            },
        );
    }

    onSubmit(e) {
        e.preventDefault();

        if (!this.state.nome || this.state.nome.length < 3) {
            this.setState({ nomeErr: true })
            return;
        }

        if (!this.state.classe) {
            this.setState({ classeErr: true })
            return;
        }

        if (!this.state.numEmp || this.state.numEmp == 0) {
            this.setState({ numEmpErr: true })
            return;
        }

        if (!this.state.codFil) {
            this.setState({ codFilErr: true })
            return;
        }

        this.setState({
            showAlert: false,
            btnLoading: true
        });

        httpPost('/unidades/save',
            {
                id: this.state.currId,
                nome: this.state.nome,
                classe: this.state.classe?.codClass,
                codfil: this.state.codFil,
                numemp: this.state.numEmp,
            },

            resp => {
                this.refresh();
                this.setState({ showForm: false });
            },

            error => {
                this.setState({
                    showAlert: true,
                    btnLoading: false,
                    msg: 'Falha ao salvar.',
                    extraMsg: error.message
                });
            },

            false
        );
    }

    onDelete(e) {
        e.preventDefault();

        this.setState({
            showAlert: false,
            btnLoading: true
        });

        httpPost('/unidades/' + this.state.currId + '/delete',
            {
                delete: true
            },

            resp => {
                this.refresh();
                this.setState({ showDelete: false });
            },

            error => {
                this.setState({
                    showAlert: true,
                    btnLoading: false,
                    msg: 'Falha ao salvar.',
                    extraMsg: error.message
                });
            },

            false
        );
    }

    onAddClick() {
        this.setState({
            currId: undefined,
            showForm: true,
            nome: '',
            nomeErr: false,
            classe: null,
            classeErr: false,
            numEmp: '',
            numEmpErr: false,
            codFil: '',
            codFilErr: false,
            showAlert: false,
            btnLoading: false,
        });
    }

    onEditClick(params) {
        this.setState({
            currId: params.row?.id,
            showForm: true,
            nome: params.row?.nome,
            nomeErr: false,
            classe: params.row?.classe,
            classeErr: false,
            numEmp: params.row?.sapiens_numemp,
            numEmpErr: false,
            codFil: params.row?.sapiens_codfil,
            codFilErr: false,
            showAlert: false,
            btnLoading: false,
        });
    }

    onRemoveClick(params) {
        this.setState({
            currId: params.row?.id,
            showDelete: true,
            showAlert: false,
            btnLoading: false,
        });
    }

    render() {
        return (
            <Stack>
                <Dialog open={this.state.showDelete}>
                    <form onSubmit={event => this.onDelete(event)}>
                        <DialogTitle color="primary" fontSize={12}>REMOVER UNIDADE</DialogTitle>
                        <DialogContent>
                            <Stack width={400} gap={2} mt={1}>
                                <Typography variant="caption">Tem certeza que deseja remover?</Typography>
                            </Stack>
                            {this.state.showAlert &&
                                <Stack mt={1} width="calc(100%)"><StatusAlert type="err" msg={this.state.msg} extra={this.state.extraMsg} /></Stack>}
                        </DialogContent>
                        <DialogActions>
                            {this.state.btnLoading ? <CircularProgress size={20} /> : <RoundButton submit>Sim</RoundButton>}
                            <RoundButton disabled={this.state.btnLoading} onClick={e => this.setState({ showDelete: false })}>Não</RoundButton>
                        </DialogActions>
                    </form>
                </Dialog>
                {/* ---------------------------------------------------------------------- */}
                <Dialog open={this.state.showForm}>
                    <form onSubmit={event => this.onSubmit(event)}>
                        <DialogTitle color="primary" fontSize={12}>{this.state.currId ? "EDITAR UNIDADE" : "ADICIONAR UNIDADE"}</DialogTitle>
                        <DialogContent>
                            <Stack width={400} gap={2} mt={1}>
                                <Stack direction="row" gap={2}>
                                    <NomeInput value={this.state.nome} onChange={(nome) => this.setState({ nome, nomeErr: false })} error={this.state.nomeErr} />
                                    <ClasseSelect value={this.state.classe} sx={{ width: 150 }} onChange={(classe) => this.setState({ classe, classeErr: false })} error={this.state.classeErr} />
                                </Stack>
                                <Stack direction="row" gap={2}>
                                    <NumEmpInput value={this.state.numEmp} onChange={(numEmp) => this.setState({ numEmp, numEmpErr: false })} error={this.state.numEmpErr} />
                                    <CodFilInput value={this.state.codFil} onChange={(codFil) => this.setState({ codFil, codFilErr: false })} error={this.state.codFilErr} />
                                </Stack>
                                {this.state.showAlert &&
                                    <Stack mt={1} width="calc(100%)"><StatusAlert type="err" msg={this.state.msg} extra={this.state.extraMsg} /></Stack>}
                            </Stack>
                        </DialogContent>
                        <DialogActions>
                            {this.state.btnLoading ? <CircularProgress size={20} /> : <RoundButton submit color={"btnStyle"}>Salvar</RoundButton>}
                            <RoundButton disabled={this.state.btnLoading} onClick={e => this.setState({ showForm: false })} >Cancelar</RoundButton>
                        </DialogActions>
                    </form>
                </Dialog>
                {/* ---------------------------------------------------------------------- */}
                <Accordion>
                    <AccordionSummary>
                        <Typography variant="body2" color="primary"><BsBuildings size={16} /><Box ml={1} component="span"><b>Cadastro de unidades</b></Box></Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box mt={-2} mb={1} borderBottom={1} borderColor="primary.main"></Box>
                        <Typography mt={1} variant="caption" color="primary">Cadastre aqui as filiais que serão gerenciadas pelo sistema.</Typography>
                        <Box><Button color={"btnStyle"} onClick={e => this.onAddClick()} size="small" variant="contained" disableElevation>Cadastrar</Button></Box>
                        <Box mt={1}>
                            <BasicDataGrid
                                dense
                                props={{
                                    //onRowClick: e => this.onUnidFichaClick(),
                                    loading: this.state.loading
                                }} rows={this.state.unidades} columns={this.columns} />
                        </Box>
                    </AccordionDetails>
                </Accordion>
            </Stack >
        );
    }
}
